<template>

  <div class="search-page">
    <div class="desktop" v-if="display === 'Desktop'">

      <div class="loadding_content" v-if="isLoadding">
        <v-container
          fill-height
          :style="'height: ' + (heightDisplay - 100) + 'px;'"
        >
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <h1 style="font-size: 70px">
                    <span style="color: #3f44a3">Kan</span>
                    <span style="color: #4a98b2">Pramool</span>
                  </h1>
                  <h3><b>กำลังเตรียมข้อมูล</b></h3>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col class="text-center" lg="4" md="4">
                  <v-progress-linear
                    color="#F8F364"
                    indeterminate
                    rounded
                    height="8"
                  >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="data_content" v-else>
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="200"
          transition="fade-transition"
        >
          <div>
            <APPBAR></APPBAR>
            <section
              id="search"
              :height="(heightDisplay - 195)"
            >
            <v-parallax
                :height="(heightDisplay - 195)"
                class="parallaxblack"
                dark
                lazy-src="https://www.kanpramool.com/img/06.jpg"
                src="https://www.kanpramool.com/img/06.jpg"
              >
              <v-container
                fill-height
              
              >
                <v-row justify="center" align="center">
                  <v-col class="text-center pl-10 pr-10" lg="7" md="7">
                    <v-row class="title_box">
                      <v-col>
                        <p style="font-size: 50px; font-weight: bold">สวัสดี</p>
                        <p style="font-size: 30px">
                          ค้นหางานก่อสร้างภาครัฐที่ตรงใจผู้รับเหมาเช่นคุณ
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="search_box">
                      <v-col>
                        <v-row class="head-tab">
                          <v-col
                            style="
                              border-top-left-radius: 10px;
                              border-top-right-radius: 10px;
                              background-color: #4ba0b2;
                              border: 1px solid #4ba0b2;
                              padding: 5px;
                            "
                          >
                            <v-tabs v-model="tab" grow>
                              <v-tabs-slider color="#4347B3"></v-tabs-slider>
                              <v-tab
                                :style="
                                  tab === 0
                                    ? 'background-color: #4BA0B2; color: #ffffff;'
                                    : 'background-color: #ffffff; color: #4347B3;'
                                "
                              >
                                <span style="font-size: 24px">
                                  <b>ประกาศเชิญชวน</b>
                                </span>
                              </v-tab>
                              <v-tab
                                :style="
                                  tab === 0
                                    ? 'background-color: #ffffff; color: #4347B3;'
                                    : 'background-color: #4BA0B2; color: #ffffff;'
                                "
                              >
                                <span style="font-size: 24px">
                                  <b>ประกาศร่าง ToR</b>
                                </span>
                              </v-tab>
                            </v-tabs>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row1"
                          style="background-color: white"
                        >
                          <v-col style="border-left: 5px solid #4ba0b2">
                            <v-autocomplete
                              style="background-color: white"
                              :menu-props="{ closeOnContentClick: true }"
                              @change="clearKeyboard()"
                              v-model="form.province"
                              :items="provinces"
                              append-icon="mdi-magnify"
                              label="เลือกจังหวัด"
                              item-text="name_th"
                              item-value="id"
                              hide-details
                              outlined
                              multiple
                              small-chips
                              dense
                              clearable
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                  close
                                  small
                                  class="chip--select-multi"
                                  @click:close="removeProvince(data.item)"
                                >
                                  {{ data.item.name_th }}
                                </v-chip>
                              </template>
                              <template v-slot:item="data">
                                <template v-if="(typeof data.item) !== 'object'">
                                  <v-list-item-content
                                    v-text="data.item"
                                  ></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content
                                    v-html="data.item.name_th"
                                  ></v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col style="border-right: 5px solid #4ba0b2">
                            <v-select
                              ref="keyboard"
                              v-model="form.jobtype"
                              :items="jobtypes"
                              item-text="job_type_name"
                              item-value="job_type_id"
                              hide-details
                              solo
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row2"
                          style="background-color: white"
                        >
                          <v-col style="border-left: 5px solid #4ba0b2">
                            <v-row>
                              <v-col lg="5" md="5" class="pr-0">
                                <v-menu
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  :return-value.sync="date1"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  :nudge-right="135"
                                  :nudge-top="15"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      color="#4367B2"
                                      style="color: white"
                                      block
                                      shaped
                                      large
                                      tile
                                      depressed
                                    >
                                      <v-icon class="mr-2" color="white">
                                        mdi-calendar
                                      </v-icon>
                                      <span v-if="tab === 0"
                                        >วันที่ยื่นซอง</span
                                      >
                                      <span v-else>วันที่ประกาศ</span>
                                    </v-btn>
                                  </template>
                                </v-menu>
                              </v-col>
                              <v-col class="pl-0">
                                <v-menu
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  :return-value.sync="date1"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      style="
                                        color: #4367b2;
                                        background-color: white;
                                      "
                                      block
                                      shaped
                                      large
                                      readonly
                                      outlined
                                      tile
                                      depressed
                                    >
                                      <span style="font-size: 16px">{{
                                        dateFormatted1
                                      }}</span>
                                    </v-btn>
                                  </template>
                                  <v-date-picker
                                    v-model="date1"
                                    locale="TH-th"
                                    @input="$refs.menu1.save(date1)"
                                    scrollable
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col style="border-right: 5px solid #4ba0b2">
                            <v-row>
                              <v-col lg="5" md="5" class="pr-0">
                                <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date2"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  :nudge-right="135"
                                  :nudge-top="15"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      color="#4367B2"
                                      style="color: white"
                                      block
                                      shaped
                                      large
                                      tile
                                      depressed
                                    >
                                      <v-icon class="mr-2" color="white">
                                        mdi-calendar
                                      </v-icon>
                                      <span>ถึงวันที่</span>
                                    </v-btn>
                                  </template>
                                </v-menu>
                              </v-col>
                              <v-col class="pl-0">
                                <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date2"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      style="
                                        color: #4367b2;
                                        background-color: white;
                                      "
                                      block
                                      shaped
                                      readonly
                                      outlined
                                      tile
                                      large
                                      depressed
                                    >
                                      <span style="font-size: 16px">{{
                                        dateFormatted2
                                      }}</span>
                                    </v-btn>
                                  </template>
                                  <v-date-picker
                                    v-model="date2"
                                    locale="TH-th"
                                    @input="$refs.menu2.save(date2)"
                                    scrollable
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row3"
                          style="background-color: white"
                        >
                          <v-col
                            style="
                              border-right: 5px solid #4ba0b2;
                              border-bottom: 5px solid #4ba0b2;
                              border-bottom-right-radius: 6px;
                              border-left: 5px solid #4ba0b2;
                            "
                          >
                            <v-btn
                              x-large
                              class="white--text"
                              color="#4347B3"
                              depressed
                              @click="searchFn()"
                            >
                              <span style="font-size: 16px">ค้นหาโครงการ</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
              </v-parallax>
              
            </section>
            <section id="map" class="pt-10 pb-10">
              <v-container class="pt-10 pb-10">
                <v-row justify="center" align="center">
                  <v-col lg="2" md="2"></v-col>
                  <v-col lg="4" md="4">
                    <h1 class="pb-4" style="color: #1165a4; font-size: 44px">
                      รวมประกาศจัดซื้อจัดจ้างภาครัฐ
                      <span style="color: #eeb834">ครอบคลุม</span>ทั่วไทย
                    </h1>
                    <p class="pt-4 pb-3" style="color: #7d8793">
                      แพลตฟอร์มออนไลน์ที่รวมประกาศจัดซื้อจัดจ้างภาครัฐ
                      (ด้วยวิธีประกวดราคา อิเล็กทรอนิกส์ e-bidding)
                      ครอบคลุมทุกหน่วยงาน ทุกจังหวัด
                      สำหรับผู้รับเหมาก่อสร้างภาครัฐโดยเฉพาะ!
                    </p>
                    <v-btn color="#EEB834"
                      ><span style="color: white"
                        >เรียนรู้เพิ่มเติม</span
                      ></v-btn
                    >
                  </v-col>
                  <v-col lg="3" md="3" class="text-left">
                    <v-img
                      lazy-src="../assets/03-01.png"
                      src="../assets/03-01.png"
                    ></v-img>
                  </v-col>
                  <v-col lg="2" md="2"></v-col>
                </v-row>
              </v-container>
            </section>
            <section
              id="why"
              style="background-color: #026cb8"
              class="pt-6 pb-6"
            >
              <v-container class="pt-10 pb-10">
                <v-row align="center" justify="center">
                  <v-col lg="2" md="2"></v-col>
                  <v-col>
                    <v-row align="center" justify="center" style="color: white">
                      <v-col class="text-center">
                        <h1 style="font-size: 38px">ทำไมต้อง KanPramool</h1>
                      </v-col>
                    </v-row>
                    <v-row align="start" justify="center">
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn
                              class="ma-2"
                              outlined
                              large
                              fab
                              color="white"
                            >
                              <h2>01</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>รู้ก่อน</p>
                            <p>รู้งานก่อนใคร นำหน้าคู่แข่ง</p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <br />
                            <hr />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn
                              class="ma-2"
                              outlined
                              large
                              fab
                              color="white"
                            >
                              <h2>02</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>ฟรี</p>
                            <p>ไม่มีค่าใช้จ่ายเพิ่มเติม ไม่ว่าจะเป็นระดับไหน</p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <br />
                            <hr />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn
                              class="ma-2"
                              outlined
                              large
                              fab
                              color="white"
                            >
                              <h2>03</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>สะดวก สบาย</p>
                            <p>มีแอพลิเคชันรองรับทั้ง Andriod เเละ IOS</p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <br />
                            <hr />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn
                              class="ma-2"
                              outlined
                              large
                              fab
                              color="white"
                            >
                              <h2>04</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>การสนับสนุน</p>
                            <p>สนับสนุนเงินทุนเเละ วัสดุก่อสร้างราคาพิเศษ</p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col lg="2" md="2"></v-col>
                </v-row>
              </v-container>
            </section>
            <section id="example-mobile" class="pt-6 pb-6">
              <v-container class="mt-6 mb-6">
                <v-row justify="center" align="center">
                  <v-col lg="2" md="2"></v-col>
                  <v-col lg="8" md="8">
                    <v-row justify="center" align="center">
                      <v-col>
                        <h1 style="font-size: 42px; color: #026cb8">
                          ระบบการค้นหาประกาศจัดซื้อจัดจ้างภาครัฐที่ตรงใจคุณ
                        </h1>
                      </v-col>
                      <v-col>
                        <p style="color: #7d8793">
                          KanPramool.com ระบบค้นหาประกาศงานก่อสร้างภาครัฐ
                          ที่สามารถค้นหาแบบ แยกประเภทงาน ระบุจังหวัดที่ต้องการ
                          เลือกพื้นที่งานที่ใกล้ตัวคุณ
                          รับการแจ้งเตือนเมื่อถึงวันยื่นซอง แชร์งานที่คุณสนใจ
                          ได้ตามความต้องการ สะดวก รวดเร็ว ตรงใจคุณ
                        </p>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="text-center">
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <v-icon class="iconshow"
                                  >mdi-magnify</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <p style="color: #7d8793; font-size: 24px">
                                  แยกประเภทค้นหา
                                </p>
                                <p style="color: #7d8793">
                                  ค้นหาแยกจังหวัด แยกประเภทงานได้
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col>
                            <v-row>
                              <v-col>
                                <v-icon class="iconshow"
                                  >mdi-map-marker-radius</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row>
                              <v-col>
                                <p style="color: #7d8793; font-size: 24px">
                                  พื้นที่ใกล้คุณ
                                </p>

                                <p style="color: #7d8793">
                                  ค้นหางานประกาศใกล้คุณ
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/mobile.png"
                              src="../assets/mobile.png"
                              max-width="450"
                            ></v-img>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row justify="center" align="center">
                          <v-col>
                            <v-row>
                              <v-col>
                                <v-icon class="iconshow"
                                  >mdi-bell</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row>
                              <v-col>
                                <p style="color: #7d8793; font-size: 24px">
                                  แจ้งเตือน
                                </p>
                                <p style="color: #7d8793">
                                  แจ้งเตือนเมื่อถึงวันยื่นซอง
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col>
                            <v-row>
                              <v-col>
                                <v-icon class="iconshow"
                                  >mdi-share-variant</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row>
                              <v-col>
                                <p style="color: #7d8793; font-size: 24px">
                                  แชร์งาน
                                </p>
                                <p style="color: #7d8793">
                                  แชร์งานประกาศที่สนใจได้
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col lg="2" md="2"></v-col>
                </v-row>
              </v-container>
            </section>
            <section id="stat">
              <v-parallax
                height="300"
                class="parallaxblack"
                dark
                lazy-src="../assets/counter-bg.png"
                src="../assets/counter-bg.png"
              >
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col class="text-center" lg="2" md="2"></v-col>
                    <v-col class="text-center" lg="8" md="8">
                      <v-row align="center" justify="center">
                        <v-col class="text-center">
                          <h1 style="font-size: 48px">
                            {{
                              countAll
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </h1>
                          <p style="font-size: 24px">จำนวนประกาศ</p>
                        </v-col>
                        <v-col class="text-center">ข้อมูลเรียลไทม์</v-col>
                        <v-col class="text-center">
                          <h1 style="font-size: 48px">
                            {{
                              (sumAll / 1000000)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </h1>
                          <p style="font-size: 24px; margin: 0px">ล้านบาท</p>
                          <p style="font-size: 24px; margin: 0px">
                            มูลค่ารวมของงานประกาศ
                          </p></v-col
                        >
                      </v-row>
                    </v-col>
                    <v-col class="text-center" lg="2" md="2"></v-col>
                  </v-row>
                </v-container>
              </v-parallax>
            </section>
            <section
              id="slide-card"
              style="background-color: white"
              class="pt-10 pb-10"
            >
              <v-slide-group
                v-model="model"
                class="pa-4"
                center-active
                show-arrows
              >
                <v-slide-item v-for="(n, index) in dataSlide" :key="index">
                  <v-card class="ma-4" width="400" @click="openData(n.url)">
                    <v-img height="150" :src="n.image_url"></v-img>
                    <v-card-title class="pb-0"
                      ><b style="color: #1165a4">{{
                        n.image_url.split("/jobtype/")[1].split(".png")[0]
                      }}</b></v-card-title
                    >
                    <v-card-text>
                      <v-row class="mx-0">
                        <v-col class="pt-0 pb-3"
                          >{{ n.project_code }}
                          <b style="color: #1165a4"
                            >[{{ n.announcement_type.split("ประกาศ")[1] }}]</b
                          ></v-col
                        >
                      </v-row>
                      <v-row class="mx-0">
                        <v-col class="pt-0 pb-0">
                          <p style="margin: 0px">
                            [จัดซื้อจัดจ้าง]
                            <b style="color: #1165a4">จังหวัด{{ n.name_th }}</b>
                          </p>
                          <p style="margin: 0px">
                            {{
                              n.project_name.split("ประกวดราคาจ้างก่อสร้าง")[1]
                            }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-row class="mx-0">
                        <v-col class="pt-3 pb-0"
                          >งบประมาณโครงการ
                          <b style="color: #1165a4">{{
                            parseInt(n.expenditure)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}</b>
                          บาท</v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </section>
            <section id="point" class="pt-6 pb-10">
              <v-container class="mt-6 mb-6">
                <v-row align="center" justify="center">
                  <v-col lg="2" md="2"></v-col>
                  <v-col lg="8" md="8" class="text-center">
                    <v-row align="center" justify="center">
                      <v-col class="text-center">
                        <h1 style="font-size: 44px; color: #1165a4">
                          เราดียังไง ?
                        </h1>
                      </v-col>
                      <v-col class="text-left">
                        <p style="color: #7d8793">
                          KanPramool.com เราดียังไง ไปดูกัน
                          ระบบค้นหาประกาศงานก่อสร้างภาครัฐของเรา
                          สามารถระบุตำแหน่งหน้างานได้ชัดเจน และสามารถค้นหาแบบ
                          แยกประเภทงานได้ตรงตามความต้องการ
                          และยังแนบเอกสารจัดซื้อจัดจ้างที่มีรายละเอียดครบถ้วนอีกด้วน
                          ทำให้ง่ายต่อการตัดสินใจในการประมูลงาน
                        </p>
                      </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-1.jpg"
                              src="../assets/team-1.jpg"
                              max-width="200"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              ระบุตำแหน่งหน้างาน
                            </p>
                            <p style="color: #7d8793">ตัดสินใจง่ายขึ้น</p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-2.jpg"
                              src="../assets/team-2.jpg"
                              max-width="200"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              แนบเอกสารจัดซื้อจัดจ้าง
                            </p>
                            <p style="color: #7d8793">
                              ดาวน์โหลดดูข้อมูลได้ทันที
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-3.jpg"
                              src="../assets/team-3.jpg"
                              max-width="200"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              รายละเอียดครบถ้วน
                            </p>
                            <p style="color: #7d8793">
                              รายละเอียดครบถ้วนไม่ตกหล่น
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-4.jpg"
                              src="../assets/team-4.jpg"
                              max-width="200"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              แยกประเภทงาน
                            </p>
                            <p style="color: #7d8793">
                              ค้นหาได้ตรงตามความต้องการ
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col lg="2" md="2"></v-col>
                </v-row>
              </v-container>
            </section>
            <section
              id="benefit"
              style="background-color: #eeeeee"
              class="pt-10 pb-10"
            >
              <v-container class="pt-12 pb-10">
                <v-row justify="center" align="center">
                  <v-col class="text-center"
                    ><h1 style="font-size: 44px; color: #1165a4">
                      ผลประโยชน์จาก KanPramool
                    </h1></v-col
                  >
                </v-row>
                <v-row justify="center" align="center" class="pb-10">
                  <v-col class="text-center">
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              ผู้ใช้งานทั่วไป
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col lg="3" md="3"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>ค้นหาประกาศใกล้คุณ</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>แจ้งเตือนผ่านไลน์ฟรี!</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>สนับสนุนเงินทุน</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>วัสดุก่อสร้างราคาพิเศษ</S>
                            </p>
                          </v-col>
                          <v-col lg="3" md="3"></v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              สมาชิก
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col lg="3" md="3"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศใกล้คุณ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >แจ้งเตือนผ่านไลน์ฟรี!
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>สนับสนุนเงินทุน</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>วัสดุก่อสร้างราคาพิเศษ</S>
                            </p>
                          </v-col>
                          <v-col lg="3" md="3"></v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                  <v-col>
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              ลูกค้าพาร์ทเนอร์
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col lg="3" md="3"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศใกล้คุณ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >แจ้งเตือนผ่านไลน์ฟรี!
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >สนับสนุนเงินทุน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >วัสดุก่อสร้างราคาพิเศษ
                            </p>
                          </v-col>
                          <v-col lg="3" md="3"></v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col lg="2" md="2"></v-col>
                  <v-col class="text-center">
                    <v-img
                      lazy-src="../assets/logo-1.png"
                      src="../assets/logo-1.png"
                      max-width="200"
                    ></v-img>
                  </v-col>
                  <v-col class="text-center">
                    <v-img
                      lazy-src="../assets/logo-2.png"
                      src="../assets/logo-2.png"
                      max-width="200"
                    ></v-img>
                  </v-col>
                  <v-col class="text-center">
                    <v-img
                      lazy-src="../assets/logo-3.png"
                      src="../assets/logo-3.png"
                      max-width="200"
                    ></v-img>
                  </v-col>
                  <v-col class="text-center">
                    <v-img
                      lazy-src="../assets/logo-4.png"
                      src="../assets/logo-4.png"
                      max-width="200"
                    ></v-img>
                  </v-col>
                  <v-col lg="2" md="2"></v-col>
                </v-row>
              </v-container>
            </section>
            <section id="footer" style="background-color: #1165a4">
              <v-container fluid>
                <v-row justify="start" align="start">
                  <v-col lg="2" md="2"></v-col>
                  <v-col class="text-center" lg="8" md="8">
                    <v-row justify="start" align="start">
                      <v-col class="text-center">
                        <v-row justify="start" align="start">
                          <v-col class="text-left">
                            <v-img
                              lazy-src="../assets/logo-transparent.png"
                              src="../assets/logo-transparent.png"
                              max-width="180"
                            ></v-img>
                            <p
                              class="pt-2"
                              style="font-size: 14px; color: white"
                            >
                              บริษัทเคเอ็มพี พาร์ทเนอร์ จำกัด (สำนักงานใหญ่) 76
                              ถนนเพชรเกษม ตำบลขันเงิน อำเภอหลังสวน จังหวัดชุมพร
                              86110
                            </p>
                            <a
                              href="https://www.kmppartners.co.th"
                              target="_BLANK"
                              class="linknew"
                            >
                              <p style="color: white">
                                <v-icon class="mr-1" color="white"
                                  >mdi-cellphone-android</v-icon
                                >
                                <span class="linkweb"
                                  >www.kmppartners.co.th</span
                                >
                              </p>
                            </a>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" lg="2" md="2">
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              บทความล่าสุด
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              เทคนิคการจัดซื้อวัสดุ
                            </p>
                            <small style="color: #eeb834">6 มกราคม 2563</small>
                            <v-divider dark></v-divider>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              เทคนิคการจัดซื้อจัดจ้าง
                            </p>
                            <small style="color: #eeb834">7 มกราคม 2563</small>
                            <v-divider dark></v-divider>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" lg="2" md="2">
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              บริการของเรา
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >หน้าเเรก
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >เกี่ยวกับเรา
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >บทความ
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >ติดต่อเรา
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              เวลาทำการ
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              การสนับสนุนของเราพร้อมให้ความช่วยเหลือคุณตลอด
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              จันทร์-เสาร์: 8.00 - 17.00
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col lg="2" md="2"></v-col>
                </v-row>
              </v-container>
            </section>
          </div>
        </v-lazy>
      </div>
    </div>
    <div class="tablet" v-else-if="display === 'Tablet'">
      <div class="loadding_content" v-if="isLoadding">
        <v-container
          fill-height
          :style="'height: ' + (heightDisplay - 100) + 'px;'"
        >
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <h1 style="font-size: 70px">
                    <span style="color: #3f44a3">Kan</span>
                    <span style="color: #4a98b2">Pramool</span>
                  </h1>
                  <h3><b>กำลังเตรียมข้อมูล</b></h3>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col class="text-center" cols="6" sm="6">
                  <v-progress-linear
                    color="#F8F364"
                    indeterminate
                    rounded
                    height="8"
                  >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="data_content" v-else>
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="200"
          transition="fade-transition"
        >
          <div>
            <APPBAR></APPBAR>
            <section
              id="search"
              style="
                background-image: url('https://www.kanpramool.com/img/banner3.jpg');
              "
            >
              <v-container
                fill-height
                :style="'height: ' + (heightDisplay - 275) + 'px;'"
              >
                <v-row justify="center" align="center">
                  <v-col class="text-center" cols="11" sm="11">
                    <v-row class="title_box">
                      <v-col>
                        <p style="font-size: 46px; font-weight: bold">สวัสดี</p>
                        <p style="font-size: 28px">
                          ค้นหางานก่อสร้างภาครัฐที่ตรงใจผู้รับเหมาเช่นคุณ
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="search_box">
                      <v-col>
                        <v-row class="head-tab">
                          <v-col
                            style="
                              border-top-left-radius: 6px;
                              border-top-right-radius: 6px;
                              background-color: #4ba0b2;
                              border: 1px solid #4ba0b2;
                              padding: 5px;
                            "
                          >
                            <v-tabs v-model="tab" grow>
                              <v-tabs-slider
                                color="#4347B3"
                                hide-slider
                              ></v-tabs-slider>
                              <v-tab
                                :style="
                                  tab === 0
                                    ? 'background-color: #4BA0B2; color: #ffffff;'
                                    : 'background-color: #ffffff; color: #4347B3;'
                                "
                              >
                                <span style="font-size: 24px">
                                  <b>ประกาศเชิญชวน</b>
                                </span>
                              </v-tab>
                              <v-tab
                                :style="
                                  tab === 0
                                    ? 'background-color: #ffffff; color: #4347B3;'
                                    : 'background-color: #4BA0B2; color: #ffffff;'
                                "
                              >
                                <span style="font-size: 24px">
                                  <b>ประกาศร่าง ToR</b>
                                </span>
                              </v-tab>
                            </v-tabs>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row1"
                          style="background-color: white"
                        >
                          <v-col style="border-left: 5px solid #4ba0b2">
                            <v-autocomplete
                              style="background-color: white"
                              :menu-props="{ closeOnContentClick: true }"
                              @change="clearKeyboard()"
                              v-model="form.province"
                              :items="provinces"
                              append-icon="mdi-magnify"
                              label="เลือกจังหวัด"
                              item-text="name_th"
                              item-value="id"
                              hide-details
                              outlined
                              multiple
                              small-chips
                              dense
                              clearable
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                  close
                                  small
                                  class="chip--select-multi"
                                  @click:close="removeProvince(data.item)"
                                >
                                  {{ data.item.name_th }}
                                </v-chip>
                              </template>
                              <template v-slot:item="data">
                                <template v-if="(typeof data.item) !== 'object'">
                                  <v-list-item-content
                                    v-text="data.item"
                                  ></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content
                                    v-html="data.item.name_th"
                                  ></v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col style="border-right: 5px solid #4ba0b2">
                            <v-select
                              ref="keyboard"
                              v-model="form.jobtype"
                              :items="jobtypes"
                              item-text="job_type_name"
                              item-value="job_type_id"
                              hide-details
                              solo
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row2"
                          style="background-color: white"
                        >
                          <v-col style="border-left: 5px solid #4ba0b2">
                            <v-row>
                              <v-col cols="5" sm="5" class="pr-0">
                                <v-menu
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  :return-value.sync="date1"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  :nudge-right="135"
                                  :nudge-top="15"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      color="#4367B2"
                                      style="color: white"
                                      block
                                      shaped
                                      large
                                      tile
                                      depressed
                                    >
                                      <v-icon class="mr-2" color="white" small>
                                        mdi-calendar
                                      </v-icon>
                                      <span v-if="tab === 0"
                                        >วันที่ยื่นซอง</span
                                      >
                                      <span v-else>วันที่ประกาศ</span>
                                    </v-btn>
                                  </template>
                                </v-menu>
                              </v-col>
                              <v-col class="pl-0">
                                <v-menu
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  :return-value.sync="date1"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      style="
                                        color: #4367b2;
                                        background-color: white;
                                      "
                                      block
                                      shaped
                                      large
                                      readonly
                                      outlined
                                      tile
                                      depressed
                                    >
                                      <span style="font-size: 16px">{{
                                        dateFormatted1
                                      }}</span>
                                    </v-btn>
                                  </template>
                                  <v-date-picker
                                    v-model="date1"
                                    locale="TH-th"
                                    @input="$refs.menu1.save(date1)"
                                    scrollable
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col style="border-right: 5px solid #4ba0b2">
                            <v-row>
                              <v-col cols="5" sm="5" class="pr-0">
                                <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date2"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  :nudge-right="135"
                                  :nudge-top="15"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      color="#4367B2"
                                      style="color: white"
                                      block
                                      shaped
                                      large
                                      tile
                                      depressed
                                    >
                                      <v-icon class="mr-2" color="white">
                                        mdi-calendar
                                      </v-icon>
                                      <span>ถึงวันที่</span>
                                    </v-btn>
                                  </template>
                                </v-menu>
                              </v-col>
                              <v-col class="pl-0">
                                <v-menu
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date2"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      style="
                                        color: #4367b2;
                                        background-color: white;
                                      "
                                      block
                                      shaped
                                      readonly
                                      outlined
                                      tile
                                      large
                                      depressed
                                    >
                                      <span style="font-size: 16px">{{
                                        dateFormatted2
                                      }}</span>
                                    </v-btn>
                                  </template>
                                  <v-date-picker
                                    v-model="date2"
                                    locale="TH-th"
                                    @input="$refs.menu2.save(date2)"
                                    scrollable
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row3"
                          style="background-color: white"
                        >
                          <v-col
                            style="
                              border-right: 5px solid #4ba0b2;
                              border-left: 5px solid #4ba0b2;
                              border-bottom: 5px solid #4ba0b2;
                            "
                          >
                            <v-btn
                              x-large
                              class="white--text"
                              color="#4347B3"
                              depressed
                              @click="searchFn()"
                            >
                              <span style="font-size: 16px">ค้นหาโครงการ</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="map" class="pt-8 pb-8">
              <v-container class="pt-8 pb-8">
                <v-row justify="center" align="center" class="pl-8 pr-8">
                  <v-col>
                    <h1 class="pb-4" style="color: #1165a4; font-size: 42px">
                      รวมประกาศจัดซื้อจัดจ้างภาครัฐ
                      <span style="color: #eeb834">ครอบคลุม</span>ทั่วไทย
                    </h1>
                    <p class="pt-4 pb-3" style="color: #7d8793">
                      แพลตฟอร์มออนไลน์ที่ประกาศจัดซื้อจัดจ้างภาครัฐ
                      (ด้วยวิธีประกวดราคา อิเล็กทรอนิกส์ e-bidding)
                      ครอบคลุมทุกหน่วยงาน ทุกจังหวัด
                      สำหรับผู้รับเหมาก่อสร้างภาครัฐโดยเฉพาะ!
                    </p>
                    <v-btn color="#EEB834"
                      ><span style="color: white"
                        >เรียนรู้เพิ่มเติม</span
                      ></v-btn
                    >
                  </v-col>
                  <v-col class="text-left">
                    <v-img
                      lazy-src="../assets/03-01.png"
                      src="../assets/03-01.png"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section
              id="why"
              style="background-color: #026cb8"
              class="pt-6 pb-6"
            >
              <v-container class="pt-10 pb-10">
                <v-row align="center" justify="center">
                  <v-col>
                    <v-row align="center" justify="center" style="color: white">
                      <v-col class="text-center">
                        <h1 style="font-size: 38px">ทำไมต้อง KanPramool</h1>
                      </v-col>
                    </v-row>
                    <v-row align="start" justify="center">
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn class="ma-2" outlined fab color="white">
                              <h2>01</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>รู้ก่อน</p>
                            <p style="font-size: 14px">
                              รู้งานก่อนใคร นำหน้าคู่แข่ง
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="1" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <br />
                            <hr />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn class="ma-2" outlined fab color="white">
                              <h2>02</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>ฟรี</p>
                            <p style="font-size: 14px">
                              ไม่มีค่าใช้จ่ายเพิ่มเติม ไม่ว่าจะเป็นระดับไหน
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="1" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <br />
                            <hr />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn class="ma-2" outlined fab color="white">
                              <h2>03</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>สะดวก สบาย</p>
                            <p style="font-size: 14px">
                              มีแอพลิเคชันรองรับทั้ง Andriod เเละ IOS
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="1" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <br />
                            <hr />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="start" justify="center">
                          <v-col class="text-center">
                            <v-btn class="ma-2" outlined fab color="white">
                              <h2>04</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center">
                            <p>การสนับสนุน</p>
                            <p style="font-size: 14px">
                              สนับสนุนเงินทุนเเละ วัสดุก่อสร้างราคาพิเศษ
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="example-mobile" class="pt-6 pb-6">
              <v-container class="mt-6 mb-6">
                <v-row justify="center" align="center" class="pl-8 pr-8">
                  <v-col lg="10" md="10">
                    <v-row justify="center" align="center">
                      <v-col>
                        <h1 style="font-size: 40px; color: #026cb8">
                          ระบบการค้นหาประกาศจัดซื้อจัดจ้างภาครัฐที่ตรงใจคุณ
                        </h1>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col>
                        <p style="color: #7d8793">
                          KanPramool.com ระบบค้นหาประกาศงานก่อสร้างภาครัฐ
                          ที่สามารถค้นหาแบบ แยกประเภทงาน ระบุจังหวัดที่ต้องการ
                          เลือกพื้นที่งานที่ใกล้ตัวคุณ
                          รับการแจ้งเตือนเมื่อถึงวันยื่นซอง แชร์งานที่คุณสนใจ
                          ได้ตามความต้องการ สะดวก รวดเร็ว ตรงใจคุณ
                        </p>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="text-center">
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <v-icon class="iconshow"
                                  >mdi-magnify</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <p style="color: #7d8793; font-size: 24px">
                                  แยกประเภทค้นหา
                                </p>
                                <p style="color: #7d8793">
                                  ค้นหาแยกจังหวัด แยกประเภทงานได้
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col>
                            <v-row>
                              <v-col>
                                <v-icon class="iconshow"
                                  >mdi-map-marker-radius</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row>
                              <v-col>
                                <p style="color: #7d8793; font-size: 24px">
                                  พื้นที่ใกล้คุณ
                                </p>

                                <p style="color: #7d8793">
                                  ค้นหางานประกาศใกล้คุณ
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/mobile.png"
                              src="../assets/mobile.png"
                              max-width="300"
                            ></v-img>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row justify="center" align="center">
                          <v-col>
                            <v-row>
                              <v-col>
                                <v-icon class="iconshow"
                                  >mdi-bell</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row>
                              <v-col>
                                <p style="color: #7d8793; font-size: 24px">
                                  แจ้งเตือน
                                </p>
                                <p style="color: #7d8793">
                                  แจ้งเตือนเมื่อถึงวันยื่นซอง
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col>
                            <v-row>
                              <v-col>
                                <v-icon class="iconshow"
                                  >mdi-share-variant</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row>
                              <v-col>
                                <p style="color: #7d8793; font-size: 24px">
                                  แชร์งาน
                                </p>
                                <p style="color: #7d8793">
                                  แชร์งานประกาศที่สนใจได้
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="stat">
              <v-parallax
                height="250"
                class="parallaxblack"
                dark
                lazy-src="../assets/counter-bg.png"
                src="../assets/counter-bg.png"
              >
                <v-container>
                  <v-row align="center" justify="center" class="pl-8 pr-8">
                    <v-col class="text-center" lg="8" md="8">
                      <v-row align="center" justify="center">
                        <v-col class="text-center">
                          <h1 style="font-size: 40px">
                            {{
                              countAll
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </h1>
                          <p style="font-size: 14px">จำนวนประกาศ</p>
                        </v-col>
                        <v-col class="text-center">ข้อมูลเรียลไทม์</v-col>
                        <v-col class="text-center">
                          <h1 style="font-size: 40px">
                            {{
                              (sumAll / 1000000)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </h1>
                          <p style="font-size: 14px; margin: 0px">ล้านบาท</p>
                          <p style="font-size: 14px; margin: 0px">
                            มูลค่ารวมของงานประกาศ
                          </p></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-parallax>
            </section>
            <section
              id="slide-card"
              style="background-color: white"
              class="pt-10 pb-10"
            >
              <v-slide-group
                v-model="model"
                class="pa-4"
                center-active
                show-arrows
              >
                <v-slide-item v-for="(n, index) in dataSlide" :key="index">
                  <v-card class="ma-4" width="280" @click="openData(n.url)">
                    <v-img height="150" :src="n.image_url"></v-img>
                    <v-card-title class="pb-0"
                      ><b style="color: #1165a4">{{
                        n.image_url.split("/jobtype/")[1].split(".png")[0]
                      }}</b></v-card-title
                    >
                    <v-card-text>
                      <v-row class="mx-0">
                        <v-col class="pt-0 pb-3"
                          >{{ n.project_code }}
                          <b style="color: #1165a4"
                            >[{{ n.announcement_type.split("ประกาศ")[1] }}]</b
                          ></v-col
                        >
                      </v-row>
                      <v-row class="mx-0">
                        <v-col class="pt-0 pb-0">
                          <p style="margin: 0px">
                            [จัดซื้อจัดจ้าง]
                            <b style="color: #1165a4">จังหวัด{{ n.name_th }}</b>
                          </p>
                          <p style="margin: 0px">
                            {{
                              n.project_name.split("ประกวดราคาจ้างก่อสร้าง")[1]
                            }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-row class="mx-0">
                        <v-col class="pt-3 pb-0"
                          >งบประมาณโครงการ
                          <b style="color: #1165a4">{{
                            (n.expenditure / 1000000)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}</b>
                          ล้านบาท</v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </section>
            <section id="point" class="pt-4 pb-4">
              <v-container class="pt-4 pb-4">
                <v-row align="center" justify="center" class="pl-6 pr-6">
                  <v-col lg="10" md="10" class="text-center">
                    <v-row align="center" justify="center">
                      <v-col class="text-center">
                        <h1 style="font-size: 44px; color: #1165a4">
                          เราดียังไง ?
                        </h1>
                      </v-col>
                      <v-col class="text-left">
                        <p style="color: #7d8793">
                          KanPramool.com เราดียังไง ไปดูกัน
                          ระบบค้นหาประกาศงานก่อสร้างภาครัฐของเรา
                          สามารถระบุตำแหน่งหน้างานได้ชัดเจน และสามารถค้นหาแบบ
                          แยกประเภทงานได้ตรงตามความต้องการ
                          และยังแนบเอกสารจัดซื้อจัดจ้างที่มีรายละเอียดครบถ้วนอีกด้วน
                          ทำให้ง่ายต่อการตัดสินใจในการประมูลงาน
                        </p>
                      </v-col>
                    </v-row>
                    <v-row align="center" justify="center">
                      <v-col cols="6" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-1.jpg"
                              src="../assets/team-1.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              ระบุตำแหน่งหน้างาน
                            </p>
                            <p style="color: #7d8793">ตัดสินใจง่ายขึ้น</p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-2.jpg"
                              src="../assets/team-2.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              แนบเอกสารจัดซื้อจัดจ้าง
                            </p>
                            <p style="color: #7d8793">
                              ดาวน์โหลดดูข้อมูลได้ทันที
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-3.jpg"
                              src="../assets/team-3.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              รายละเอียดครบถ้วน
                            </p>
                            <p style="color: #7d8793">
                              รายละเอียดครบถ้วนไม่ตกหล่น
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-4.jpg"
                              src="../assets/team-4.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 23px; color: #1165a4">
                              แยกประเภทงาน
                            </p>
                            <p style="color: #7d8793">
                              ค้นหาได้ตรงตามความต้องการ
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section
              id="benefit"
              style="background-color: #eeeeee"
              class="pt-10 pb-10"
            >
              <v-container class="pt-8 pb-6">
                <v-row justify="center" align="center">
                  <v-col class="text-center"
                    ><h1 style="font-size: 44px; color: #1165a4">
                      ผลประโยชน์จาก KanPramool
                    </h1></v-col
                  >
                </v-row>
                <v-row justify="center" align="center">
                  <v-col cols="2"></v-col>
                  <v-col class="text-center">
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              ผู้ใช้งานทั่วไป
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="3" md="3"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>ค้นหาประกาศใกล้คุณ</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>แจ้งเตือนผ่านไลน์ฟรี!</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>สนับสนุนเงินทุน</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>วัสดุก่อสร้างราคาพิเศษ</S>
                            </p>
                          </v-col>
                          <v-col cols="2" md="2"></v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                  <v-col cols="2"></v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col cols="2"></v-col>
                  <v-col class="text-center">
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              สมาชิก
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="3" md="3"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศใกล้คุณ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >แจ้งเตือนผ่านไลน์ฟรี!
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>สนับสนุนเงินทุน</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>วัสดุก่อสร้างราคาพิเศษ</S>
                            </p>
                          </v-col>
                          <v-col cols="2" md="2"></v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                  <v-col cols="2"></v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col cols="2"></v-col>
                  <v-col class="text-center">
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              ลูกค้าพาร์ทเนอร์
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="3" md="3"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศใกล้คุณ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >แจ้งเตือนผ่านไลน์ฟรี!
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >สนับสนุนเงินทุน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >วัสดุก่อสร้างราคาพิเศษ
                            </p>
                          </v-col>
                          <v-col cols="2" md="2"></v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                  <v-col cols="2"></v-col>
                </v-row>
              </v-container>
              <v-container fluid>
                <v-row justify="center" align="center">
                  <v-col cols="2"></v-col>
                  <v-col class="text-center">
                    <v-row justify="center" align="center">
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-1.png"
                          src="../assets/logo-1.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-2.png"
                          src="../assets/logo-2.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2"></v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col cols="2"></v-col>
                  <v-col class="text-center">
                    <v-row>
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-3.png"
                          src="../assets/logo-3.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-4.png"
                          src="../assets/logo-4.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2"></v-col>
                </v-row>
              </v-container>
            </section>
            <section id="footer" style="background-color: #1165a4">
              <v-container fluid>
                <v-row justify="center" align="start">
                  <v-col class="text-center" lg="10" md="10">
                    <v-row justify="start" align="start">
                      <v-col class="text-center">
                        <v-row justify="start" align="start">
                          <v-col class="text-left">
                            <v-img
                              lazy-src="../assets/logo-transparent.png"
                              src="../assets/logo-transparent.png"
                              max-width="180"
                            ></v-img>
                            <p
                              class="pt-2"
                              style="font-size: 13px; color: white"
                            >
                              บริษัทเคเอ็มพี พาร์ทเนอร์ จำกัด (สำนักงานใหญ่) 76
                              ถนนเพชรเกษม ตำบลขันเงิน อำเภอหลังสวน จังหวัดชุมพร
                              86110
                            </p>
                            <a
                              href="https://www.kmppartners.co.th"
                              target="_BLANK"
                              class="linknew"
                            >
                              <p style="color: white; font-size: 13px">
                                <v-icon class="mr-1" color="white"
                                  >mdi-cellphone-android</v-icon
                                >
                                <span class="linkweb"
                                  >www.kmppartners.co.th</span
                                >
                              </p>
                            </a>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" lg="2" md="2">
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              บทความล่าสุด
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              เทคนิคการจัดซื้อวัสดุ
                            </p>
                            <small style="color: #eeb834">6 มกราคม 2563</small>
                            <v-divider dark></v-divider>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              เทคนิคการจัดซื้อจัดจ้าง
                            </p>
                            <small style="color: #eeb834">7 มกราคม 2563</small>
                            <v-divider dark></v-divider>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" lg="2" md="2">
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              บริการของเรา
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >หน้าเเรก
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >เกี่ยวกับเรา
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >บทความ
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >ติดต่อเรา
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col>
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              เวลาทำการ
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              การสนับสนุนของเราพร้อมให้ความช่วยเหลือคุณตลอด
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              จันทร์-เสาร์: 8.00 - 17.00
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
          </div>
        </v-lazy>
      </div>
    </div>
    <div class="mobile" v-else>
      <div class="loadding_content" v-if="isLoadding">
        <v-container
          fill-height
          :style="'height: ' + (heightDisplay - 225) + 'px;'"
        >
          <v-row align="center" justify="center">
            <v-col class="text-center">
              <v-row align="center" justify="center">
                <v-col class="text-center">
                  <h1 style="font-size: 40px">
                    <span style="color: #3f44a3">Kan</span>
                    <span style="color: #4a98b2">Pramool</span>
                  </h1>
                  <h5><b>กำลังเตรียมข้อมูล</b></h5>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col class="text-center" cols="7" sm="7">
                  <v-progress-linear
                    color="#F8F364"
                    indeterminate
                    rounded
                    height="8"
                  >
                  </v-progress-linear>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="data_content" v-else>
        <v-lazy
          v-model="isActive"
          :options="{
            threshold: 0.5,
          }"
          min-height="200"
          transition="fade-transition"
        >
          <div>
            <APPBAR></APPBAR>
            <section id="search">
              <v-container class="search-mobile">
                <v-row justify="center" align="center">
                  <v-col class="text-center" cols="11" sm="11">
                    <v-row class="title_box">
                      <v-col>
                        <p style="font-size: 30px; font-weight: bold">สวัสดี</p>
                        <p style="font-size: 16px">
                          ค้นหางานก่อสร้างภาครัฐที่ตรงใจผู้รับเหมาเช่นคุณ
                        </p>
                      </v-col>
                    </v-row>
                    <v-row class="search_box">
                      <v-col>
                        <v-row class="head-tab">
                          <v-col
                            style="
                              border-top-left-radius: 6px;
                              border-top-right-radius: 6px;
                              background-color: #4ba0b2;
                              border: 1px solid #4ba0b2;
                              padding: 5px;
                            "
                          >
                            <v-tabs
                              class="tabs-head"
                              v-model="tab"
                              grow
                              :show-arrows="false"
                              slider-color="#4347B3"
                            >
                              <v-tab
                                :style="
                                  tab === 0
                                    ? 'background-color: #4BA0B2; color: #ffffff;'
                                    : 'background-color: #ffffff; color: #4347B3;'
                                "
                              >
                                <span style="font-size: 14px">
                                  <b>ประกาศเชิญชวน</b>
                                </span>
                              </v-tab>
                              <v-tab
                                :style="
                                  tab === 0
                                    ? 'background-color: #ffffff; color: #4347B3;'
                                    : 'background-color: #4BA0B2; color: #ffffff;'
                                "
                              >
                                <span style="font-size: 14px">
                                  <b>ประกาศร่าง ToR</b>
                                </span>
                              </v-tab>
                            </v-tabs>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row1"
                          style="background-color: white"
                        >
                          <v-col
                            style="
                              border-left: 5px solid #4ba0b2;
                              border-right: 5px solid #4ba0b2;
                            "
                            cols="12"
                            sm="12"
                          >
                            <v-autocomplete
                              style="z-index: 150; background-color: white"
                              :menu-props="{ closeOnContentClick: true }"
                              @change="clearKeyboard()"
                              v-model="form.province"
                              :items="provinces"
                              append-icon="mdi-magnify"
                              label="เลือกจังหวัด"
                              item-text="name_th"
                              item-value="id"
                              hide-details
                              outlined
                              multiple
                              small-chips
                              dense
                              clearable
                            >
                              <template v-slot:selection="data">
                                <v-chip
                                  close
                                  small
                                  class="chip--select-multi"
                                  @click:close="removeProvince(data.item)"
                                >
                                  {{ data.item.name_th }}
                                </v-chip>
                              </template>
                              <template v-slot:item="data">
                                <template v-if="(typeof data.item) !== 'object'">
                                  <v-list-item-content
                                    v-text="data.item"
                                  ></v-list-item-content>
                                </template>
                                <template v-else>
                                  <v-list-item-content
                                    v-html="data.item.name_th"
                                  ></v-list-item-content>
                                </template>
                              </template>
                            </v-autocomplete>
                          </v-col>
                          <v-col
                            style="
                              border-right: 5px solid #4ba0b2;
                              border-left: 5px solid #4ba0b2;
                            "
                            cols="12"
                            sm="12"
                          >
                            <v-select
                              style="z-index: 150"
                              ref="keyboard"
                              v-model="form.jobtype"
                              :items="jobtypes"
                              item-text="job_type_name"
                              item-value="job_type_id"
                              hide-details
                              solo
                              dense
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row2"
                          style="background-color: white"
                        >
                          <v-col
                            style="
                              border-left: 5px solid #4ba0b2;
                              border-right: 5px solid #4ba0b2;
                            "
                            cols="12"
                            sm="12"
                          >
                            <v-row>
                              <v-col cols="5" sm="5" class="pr-0 pb-0">
                                <v-menu
                                  style="z-index: 150"
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  :return-value.sync="date1"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  :nudge-right="135"
                                  :nudge-top="15"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      color="#4367B2"
                                      style="color: white"
                                      block
                                      shaped
                                      large
                                      tile
                                      depressed
                                    >
                                      <v-icon class="mr-2" color="white" small>
                                        mdi-calendar
                                      </v-icon>
                                      <span
                                        v-if="tab === 0"
                                        style="font-size: 10px"
                                        >วันที่ยื่นซอง</span
                                      >
                                      <span style="font-size: 10px" v-else
                                        >วันที่ประกาศ</span
                                      >
                                    </v-btn>
                                  </template>
                                </v-menu>
                              </v-col>
                              <v-col class="pl-0 pb-0">
                                <v-menu
                                  style="z-index: 150"
                                  ref="menu1"
                                  v-model="menu1"
                                  :close-on-content-click="false"
                                  :return-value.sync="date1"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      style="
                                        color: #4367b2;
                                        background-color: white;
                                      "
                                      block
                                      shaped
                                      large
                                      readonly
                                      outlined
                                      tile
                                      depressed
                                    >
                                      <span style="font-size: 14px">{{
                                        dateFormatted1
                                      }}</span>
                                    </v-btn>
                                  </template>
                                  <v-date-picker
                                    style="z-index: 150"
                                    v-model="date1"
                                    locale="TH-th"
                                    @input="$refs.menu1.save(date1)"
                                    scrollable
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-col>
                          <v-col
                            style="
                              border-right: 5px solid #4ba0b2;
                              border-left: 5px solid #4ba0b2;
                            "
                            cols="12"
                            sm="12"
                          >
                            <v-row>
                              <v-col cols="5" sm="5" class="pr-0 pt-0">
                                <v-menu
                                  style="z-index: 150"
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date2"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  :nudge-right="135"
                                  :nudge-top="15"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      color="#4367B2"
                                      style="color: white"
                                      block
                                      shaped
                                      large
                                      tile
                                      depressed
                                    >
                                      <v-icon class="mr-2" color="white" small>
                                        mdi-calendar
                                      </v-icon>
                                      <span style="font-size: 10px"
                                        >จนถึงวันที่</span
                                      >
                                    </v-btn>
                                  </template>
                                </v-menu>
                              </v-col>
                              <v-col class="pl-0 pt-0">
                                <v-menu
                                  style="z-index: 150"
                                  ref="menu2"
                                  v-model="menu2"
                                  :close-on-content-click="false"
                                  :return-value.sync="date2"
                                  transition="scale-transition"
                                  min-width="290px"
                                  max-width="290px"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      class="d-inline"
                                      prepend-icon="mdi-calendar"
                                      v-on="on"
                                      v-bind="attrs"
                                      style="
                                        color: #4367b2;
                                        background-color: white;
                                      "
                                      block
                                      shaped
                                      readonly
                                      outlined
                                      tile
                                      large
                                      depressed
                                    >
                                      <span style="font-size: 14px">{{
                                        dateFormatted2
                                      }}</span>
                                    </v-btn>
                                  </template>
                                  <v-date-picker
                                    style="z-index: 150"
                                    v-model="date2"
                                    locale="TH-th"
                                    @input="$refs.menu2.save(date2)"
                                    scrollable
                                  >
                                  </v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row
                          class="search_row3"
                          style="background-color: white"
                        >
                          <v-col
                            style="
                              border-right: 5px solid #4ba0b2;
                              border-bottom: 5px solid #4ba0b2;
                              border-bottom-right-radius: 6px;
                              border-left: 5px solid #4ba0b2;
                            "
                          >
                            <v-btn
                              small
                              class="white--text"
                              color="#4347B3"
                              depressed
                              @click="searchFn()"
                            >
                              <span style="font-size: 14px">ค้นหาโครงการ</span>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="map" class="pt-6 pb-6">
              <v-container class="pt-6 pb-6">
                <v-row justify="center" align="center" class="pl-4 pr-4">
                  <v-col class="text-left">
                    <h1 class="pb-4" style="color: #1165a4; font-size: 25px">
                      รวมประกาศจัดซื้อจัดจ้างภาครัฐ
                      <span style="color: #eeb834">ครอบคลุม</span>ทั่วไทย
                    </h1>
                    <p class="pt-4 pb-3" style="color: #7d8793">
                      แพลตฟอร์มออนไลน์ที่ประกาศจัดซื้อจัดจ้างภาครัฐ
                      (ด้วยวิธีประกวดราคา อิเล็กทรอนิกส์ e-bidding)
                      ครอบคลุมทุกหน่วยงาน ทุกจังหวัด
                      สำหรับผู้รับเหมาก่อสร้างภาครัฐโดยเฉพาะ!
                    </p>
                    <v-btn small color="#EEB834"
                      ><span style="color: white"
                        >เรียนรู้เพิ่มเติม</span
                      ></v-btn
                    >
                  </v-col>
                </v-row>
                <v-row justify="center" align="center" class="pl-4 pr-4">
                  <v-col class="text-center">
                    <v-img
                      lazy-src="../assets/03-01.png"
                      src="../assets/03-01.png"
                    ></v-img>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="why" style="background-color: #026cb8">
              <v-container>
                <v-row align="center" justify="center">
                  <v-col>
                    <v-row align="center" justify="center" style="color: white">
                      <v-col class="text-center">
                        <h1 style="font-size: 25px">ทำไมต้อง KanPramool</h1>
                      </v-col>
                    </v-row>
                    <v-row align="start" justify="center">
                      <v-col class="text-center" cols="12">
                        <v-row align="start" justify="center">
                          <v-col class="text-center pb-0">
                            <v-btn
                              class="ma-2"
                              outlined
                              fab
                              large
                              color="white"
                            >
                              <h2>01</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center pt-0">
                            <p>รู้ก่อน</p>
                            <p style="font-size: 14px">
                              รู้งานก่อนใคร นำหน้าคู่แข่ง
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row align="start" justify="center">
                          <v-col class="text-center pb-0">
                            <v-btn
                              large
                              class="ma-2"
                              outlined
                              fab
                              color="white"
                            >
                              <h2>02</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center pt-0">
                            <p>ฟรี</p>
                            <p style="font-size: 14px">
                              ไม่มีค่าใช้จ่ายเพิ่มเติม ไม่ว่าจะเป็นระดับไหน
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row align="start" justify="center">
                          <v-col class="text-center pb-0">
                            <v-btn
                              large
                              class="ma-2"
                              outlined
                              fab
                              color="white"
                            >
                              <h2>03</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center pt-0">
                            <p>สะดวก สบาย</p>
                            <p style="font-size: 14px">
                              มีแอพลิเคชันรองรับทั้ง Andriod เเละ IOS
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row align="start" justify="center">
                          <v-col class="text-center pb-0">
                            <v-btn
                              large
                              class="ma-2"
                              outlined
                              fab
                              color="white"
                            >
                              <h2>04</h2>
                            </v-btn>
                          </v-col>
                        </v-row>
                        <v-row
                          align="start"
                          justify="center"
                          style="color: white"
                        >
                          <v-col class="text-center pt-0">
                            <p>การสนับสนุน</p>
                            <p style="font-size: 14px">
                              สนับสนุนเงินทุนเเละ วัสดุก่อสร้างราคาพิเศษ
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="example-mobile" class="pt-6 pb-6">
              <v-container>
                <v-row justify="center" align="center" class="pl-8 pr-8">
                  <v-col lg="10" md="10">
                    <v-row justify="center" align="center">
                      <v-col>
                        <h1 style="font-size: 26px; color: #026cb8">
                          ระบบการค้นหาประกาศจัดซื้อจัดจ้างภาครัฐที่ตรงใจคุณ
                        </h1>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col>
                        <p style="color: #7d8793; font-size: 12px">
                          KanPramool.com ระบบค้นหาประกาศงานก่อสร้างภาครัฐ
                          ที่สามารถค้นหาแบบ แยกประเภทงาน ระบุจังหวัดที่ต้องการ
                          เลือกพื้นที่งานที่ใกล้ตัวคุณ
                          รับการแจ้งเตือนเมื่อถึงวันยื่นซอง แชร์งานที่คุณสนใจ
                          ได้ตามความต้องการ สะดวก รวดเร็ว ตรงใจคุณ
                        </p>
                      </v-col>
                    </v-row>
                    <v-row justify="center" align="center">
                      <v-col class="text-center" cols="12">
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-row justify="center" align="center">
                              <v-col class="text-center pt-0 pb-0">
                                <v-icon class="iconshow"
                                  >mdi-magnify</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <p style="color: #7d8793; font-size: 24px">
                                  แยกประเภทค้นหา
                                </p>
                                <p style="color: #7d8793">
                                  ค้นหาแยกจังหวัด แยกประเภทงานได้
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-row justify="center" align="center">
                              <v-col class="text-center pt-0 pb-0">
                                <v-icon class="iconshow"
                                  >mdi-map-marker-radius</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <p style="color: #7d8793; font-size: 24px">
                                  พื้นที่ใกล้คุณ
                                </p>

                                <p style="color: #7d8793">
                                  ค้นหางานประกาศใกล้คุณ
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/mobile.png"
                              src="../assets/mobile.png"
                              max-width="300"
                            ></v-img>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-row justify="center" align="center">
                              <v-col class="pt-0 pb-0 text-center">
                                <v-icon class="iconshow"
                                  >mdi-bell</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <p style="color: #7d8793; font-size: 24px">
                                  แจ้งเตือน
                                </p>
                                <p style="color: #7d8793">
                                  แจ้งเตือนเมื่อถึงวันยื่นซอง
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <v-row justify="center" align="center">
                              <v-col class="pt-0 pb-0 text-center">
                                <v-icon class="iconshow"
                                  >mdi-share-variant</v-icon
                                ></v-col
                              >
                            </v-row>
                            <v-row justify="center" align="center">
                              <v-col class="text-center">
                                <p style="color: #7d8793; font-size: 24px">
                                  แชร์งาน
                                </p>
                                <p style="color: #7d8793">
                                  แชร์งานประกาศที่สนใจได้
                                </p>
                              </v-col>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="stat">
              <v-parallax
                height="250"
                class="parallaxblack"
                dark
                lazy-src="../assets/counter-bg.png"
                src="../assets/counter-bg.png"
              >
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col class="text-center" lg="10" md="10">
                      <v-row align="center" justify="center">
                        <v-col class="text-center" cols="12">
                          <h1 style="font-size: 20px">
                            {{
                              countAll
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </h1>
                          <p style="font-size: 12px">จำนวนประกาศ</p>
                        </v-col>
                        <v-col class="text-center" cols="12"
                          ><span style="font-size: 10px"
                            >ข้อมูลเรียลไทม์</span
                          ></v-col
                        >
                        <v-col class="text-center" cols="12">
                          <h1 style="font-size: 20px">
                            {{
                              (sumAll / 1000000)
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            }}
                          </h1>
                          <p style="font-size: 12px; margin: 0px">ล้านบาท</p>
                          <p style="font-size: 12px; margin: 0px">
                            มูลค่ารวมของงานประกาศ
                          </p></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-parallax>
            </section>
            <section
              id="slide-card"
              style="background-color: white"
              class="pt-10 pb-10"
            >
              <v-slide-group v-model="model" center-active show-arrows>
                <v-slide-item v-for="(n, index) in dataSlide" :key="index">
                  <v-card width="250" @click="openData(n.url)">
                    <v-img height="150" :src="n.image_url"></v-img>
                    <v-card-title class="pb-0"
                      ><b style="color: #1165a4">{{
                        n.image_url.split("/jobtype/")[1].split(".png")[0]
                      }}</b></v-card-title
                    >
                    <v-card-text>
                      <v-row class="mx-0">
                        <v-col class="pt-0 pb-3"
                          >{{ n.project_code }}
                          <b style="color: #1165a4; font-size: 12px"
                            >[{{ n.announcement_type.split("ประกาศ")[1] }}]</b
                          ></v-col
                        >
                      </v-row>
                      <v-row class="mx-0">
                        <v-col class="pt-0 pb-0">
                          <p style="margin: 0px; font-size: 12px">
                            [จัดซื้อจัดจ้าง]
                            <b style="color: #1165a4; font-size: 12px"
                              >จังหวัด{{ n.name_th }}</b
                            >
                          </p>
                          <p style="margin: 0px; font-size: 12px">
                            {{
                              n.project_name.split("ประกวดราคาจ้างก่อสร้าง")[1]
                            }}
                          </p>
                        </v-col>
                      </v-row>
                      <v-row class="mx-0">
                        <v-col class="pt-3 pb-0"
                          ><span style="font-size: 12px">งบประมาณโครงการ </span>
                          <b style="color: #1165a4; font-size: 12px">{{
                            (n.expenditure / 1000000)
                              .toFixed(2)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                          }}</b>
                          ล้านบาท</v-col
                        >
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </section>
            <section id="point" class="pt-4 pb-4">
              <v-container>
                <v-row align="center" justify="center" class="pl-6 pr-6">
                  <v-col lg="10" md="10" class="text-center">
                    <v-row align="center" justify="center">
                      <v-col class="text-center" cols="12">
                        <h1 style="font-size: 44px; color: #1165a4">
                          เราดียังไง ?
                        </h1>
                      </v-col>
                      <v-col class="text-left" cols="12">
                        <p style="color: #7d8793; font-size: 12px">
                          KanPramool.com เราดียังไง ไปดูกัน
                          ระบบค้นหาประกาศงานก่อสร้างภาครัฐของเรา
                          สามารถระบุตำแหน่งหน้างานได้ชัดเจน และสามารถค้นหาแบบ
                          แยกประเภทงานได้ตรงตามความต้องการ
                          และยังแนบเอกสารจัดซื้อจัดจ้างที่มีรายละเอียดครบถ้วนอีกด้วน
                          ทำให้ง่ายต่อการตัดสินใจในการประมูลงาน
                        </p>
                      </v-col>
                    </v-row>
                    <v-row align="start" justify="center">
                      <v-col cols="6" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-1.jpg"
                              src="../assets/team-1.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 18px; color: #1165a4">
                              ระบุตำแหน่งหน้างาน
                            </p>
                            <p style="color: #7d8793; font-size: 14px">
                              ตัดสินใจง่ายขึ้น
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-2.jpg"
                              src="../assets/team-2.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 18px; color: #1165a4">
                              แนบเอกสารจัดซื้อจัดจ้าง
                            </p>
                            <p style="color: #7d8793; font-size: 14px">
                              ดาวน์โหลดดูข้อมูลได้ทันที
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-3.jpg"
                              src="../assets/team-3.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 18px; color: #1165a4">
                              รายละเอียดครบถ้วน
                            </p>
                            <p style="color: #7d8793; font-size: 14px">
                              รายละเอียดครบถ้วนไม่ตกหล่น
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <v-img
                              lazy-src="../assets/team-4.jpg"
                              src="../assets/team-4.jpg"
                            ></v-img>
                          </v-col>
                        </v-row>
                        <v-row align="center" justify="center">
                          <v-col class="text-center">
                            <p style="font-size: 18px; color: #1165a4">
                              แยกประเภทงาน
                            </p>
                            <p style="color: #7d8793; font-size: 14px">
                              ค้นหาได้ตรงตามความต้องการ
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section
              id="benefit"
              style="background-color: #eeeeee"
              class="pt-10 pb-10"
            >
              <v-container class="pt-4 pb-4">
                <v-row justify="center" align="center">
                  <v-col class="text-center"
                    ><h1 style="font-size: 26px; color: #1165a4">
                      ผลประโยชน์จาก KanPramool
                    </h1></v-col
                  >
                </v-row>
                <v-row justify="center" align="center">
                  <v-col class="text-center">
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              ผู้ใช้งานทั่วไป
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="1" md="1"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>ค้นหาประกาศใกล้คุณ</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>แจ้งเตือนผ่านไลน์ฟรี!</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>สนับสนุนเงินทุน</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>วัสดุก่อสร้างราคาพิเศษ</S>
                            </p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col class="text-center">
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              สมาชิก
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="1" md="1"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศใกล้คุณ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >แจ้งเตือนผ่านไลน์ฟรี!
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>สนับสนุนเงินทุน</S>
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-close-thick</v-icon
                              ><S>วัสดุก่อสร้างราคาพิเศษ</S>
                            </p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col class="text-center">
                    <v-card elevation="2">
                      <v-container>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <p
                              style="
                                color: #1165a4;
                                font-size: 22px;
                                margin: 0px;
                              "
                            >
                              ลูกค้าพาร์ทเนอร์
                            </p>
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col class="text-center">
                            <hr style="width: 70%; margin: auto" class="mb-3" />
                            <p
                              style="
                                font-size: 44px;
                                color: #1165a4;
                                margin: 0px;
                              "
                            >
                              ฟรี!
                            </p>
                            <hr style="width: 70%; margin: auto" class="mt-3" />
                          </v-col>
                        </v-row>
                        <v-row justify="center" align="center">
                          <v-col cols="1" md="1"></v-col>
                          <v-col class="text-left">
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาเเยกตามจังหวัด
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้าหาเเยกตามประเภทงาน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดาวน์โหลดหนังสือจัดซื้อจัดจ้าง
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ดูตำเเหน่งหน้างานได้
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >เเชร์ประกาศที่สนใจ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >ค้นหาประกาศใกล้คุณ
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >แจ้งเตือนผ่านไลน์ฟรี!
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >สนับสนุนเงินทุน
                            </p>
                            <p>
                              <v-icon class="mr-2" style="color: #eeb834"
                                >mdi-check-bold</v-icon
                              >วัสดุก่อสร้างราคาพิเศษ
                            </p>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
              <v-container fluid>
                <v-row justify="center" align="center">
                  <v-col class="text-center">
                    <v-row justify="center" align="center">
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-1.png"
                          src="../assets/logo-1.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-2.png"
                          src="../assets/logo-2.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row justify="center" align="center">
                  <v-col class="text-center">
                    <v-row>
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-3.png"
                          src="../assets/logo-3.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <v-img
                          lazy-src="../assets/logo-4.png"
                          src="../assets/logo-4.png"
                          max-width="200"
                        ></v-img>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
            <section id="footer" style="background-color: #1165a4">
              <v-container fluid>
                <v-row justify="center" align="start">
                  <v-col class="text-center" cols="10">
                    <v-row justify="start" align="start">
                      <v-col class="text-center" cols="12">
                        <v-row justify="start" align="start">
                          <v-col class="text-left">
                            <v-img
                              lazy-src="../assets/logo-transparent.png"
                              src="../assets/logo-transparent.png"
                              max-width="180"
                            ></v-img>
                            <p
                              class="pt-2"
                              style="font-size: 13px; color: white"
                            >
                              บริษัท เคเอ็มพี พาร์ทเนอร์ จำกัด (สำนักงานใหญ่) 76
                              ถนน เพชรเกษม ตำบล ขันเงิน อำเภอ หลังสวน จังหวัด ชุมพร
                              86110
                            </p>
                            <a
                              href="https://www.kmppartners.co.th"
                              target="_BLANK"
                              class="linknew"
                            >
                              <p style="color: white; font-size: 13px">
                                <v-icon class="mr-1" color="white"
                                  >mdi-cellphone-android</v-icon
                                >
                                <span class="linkweb"
                                  >www.kmppartners.co.th</span
                                >
                              </p>
                            </a>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              บทความล่าสุด
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              เทคนิคการจัดซื้อวัสดุ
                            </p>
                            <small style="color: #eeb834">6 มกราคม 2563</small>
                            <v-divider dark></v-divider>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              เทคนิคการจัดซื้อจัดจ้าง
                            </p>
                            <small style="color: #eeb834">7 มกราคม 2563</small>
                            <v-divider dark></v-divider>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              บริการของเรา
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >หน้าเเรก
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >เกี่ยวกับเรา
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >บทความ
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              <v-icon color="#eeb834">mdi-menu-right</v-icon
                              >ติดต่อเรา
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="text-center" cols="12">
                        <v-row justify="center" align="start">
                          <v-col class="text-left">
                            <p
                              style="color: white; font-size: 24px; margin: 0px"
                            >
                              เวลาทำการ
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              การสนับสนุนของเราพร้อมให้ความช่วยเหลือคุณตลอด
                            </p>
                            <p
                              style="color: white; font-size: 14px; margin: 0px"
                              class="pt-3"
                            >
                              จันทร์-เสาร์: 8.00 - 17.00
                            </p>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </section>
          </div>
        </v-lazy>
      </div>
    </div>
  </div>
</template>

 <script>
import APPBAR from "../components/appBar";
export default {
  components: { APPBAR },
  data: () => ({
    model: null,
    isActive: false,
    toggle_exclusive: 2,
    startDateStatus: false,
    display: null,
    heightDisplay: null,
    widthDisplay: null,
    tab: 0,
    date1: null,
    menu1: false,
    dateFormatted1: null,
    date2: null,
    menu2: false,
    dateFormatted2: null,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    isLogin: false,
    isLoadding: true,
    provinces: [],
    jobtypes: [],
    form: {
      page: 1,
      announcement_type: "invite",
      province: [],
      jobtype: "All",
      start_date:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
      end_date:
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate(),
      ipaddress: null,
      click: true,
      countAll: 0,
      sumAll: 0,
      dataSlide: [],
    },
  }),
  created() {
    this.checkDisplay();
    this.checkHightDisplay();
    let date = new Date();
    date.setDate(date.getDate() + 10);
    this.date1 =
      new Date().getFullYear() +
      "-" +
      ((new Date().getMonth() + 1).toString().length === 1
        ? "0" + (new Date().getMonth() + 1)
        : new Date().getMonth() + 1) +
      "-" +
      (new Date().getDate().toString().length === 1
        ? "0" + new Date().getDate()
        : new Date().getDate());
    this.dateFormatted1 = this.formatDate(this.date1);
    this.date2 =
      date.getFullYear() +
      "-" +
      ((date.getMonth() + 1).toString().length === 1
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate().toString().length === 1
        ? "0" + date.getDate()
        : date.getDate());
    this.dateFormatted2 = this.formatDate(this.date2);
    this.getIPAddress().then(() => {
      this.getProvinces().then(() => {
        this.getJobtype().then(() => {
          this.getDataRealTime().then(() => {
            this.getDateSlide().then(() => {
              this.loaddingPage();
            });
          });
        });
      });
    });
  },
  mounted() {
    if (localStorage.getItem("fullname_customer") === null) {
      this.isLogin = false;
    } else {
      this.isLogin = true;
    }
    if (this.$session.get("objSearch") === undefined) {
      this.form.start_date =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate();
      this.form.end_date =
        new Date().getFullYear() +
        "-" +
        (new Date().getMonth() + 1) +
        "-" +
        new Date().getDate();
      this.form.jobtype = "All";
      this.form.province = [];
      this.form.announcement_type = "invite";
      this.dateFormatted2 = this.formatDate(this.form.end_date);
      this.dateFormatted1 = this.formatDate(this.form.start_date);
      this.tab = 0;
      this.form.page = 1;
    } else {
      this.form.start_date = this.$session.get("objSearch").start_date;
      this.form.end_date = this.$session.get("objSearch").end_date;
      this.form.jobtype = this.$session.get("objSearch").jobtype;
      this.form.province = this.$session.get("objSearch").province;
      this.form.page = this.$session.get("objSearch").page;
      this.form.announcement_type = this.$session.get(
        "objSearch"
      ).announcement_type;
      this.dateFormatted2 = this.formatDate(this.form.end_date);
      this.dateFormatted1 = this.formatDate(this.form.start_date);
      if (this.form.announcement_type === "ebidding") {
        this.tab = 2;
      } else if (this.form.announcement_type === "tor") {
        this.tab = 1;
      } else if (this.form.announcement_type === "invite") {
        this.tab = 0;
      }
    }
  },
  watch: {
    date1() {
      this.dateFormatted1 = this.formatDate(this.date1);
      this.form.start_date = this.date1;
    },
    date2() {
      // continue pop up alert date2 > date1
      this.dateFormatted2 = this.formatDate(this.date2);
      this.form.end_date = this.date2;
    },
    tab() {
      if (this.tab === 0) {
        this.form.announcement_type = "invite";
      } else if (this.tab === 1) {
        this.form.announcement_type = "tor";
      } else if (this.tab === 2) {
        this.form.announcement_type = "ebidding";
      }
    },
  },
  methods: {
    getDataRealTime() {
      return this.$axios.get(this.api + "/datarealtime").then((res) => {
        this.sumAll = res.data.response[0].sumAll;
        this.countAll = res.data.response[0].countAll;
      });
    },
    clearKeyboard() {
      this.$refs.keyboard.focus();
    },
    getIPAddress() {
      return this.$axios
        .get("https://api.db-ip.com/v2/free/self")
        .then((res) => {
          if (res.data.ipAddress !== undefined || res.data.ipAddress !== null) {
            this.form.ipaddress = res.data.ipAddress;
          } else {
            location.reload();
          }
        });
    },
    searchFn() {
      if (this.form.province.length > 0) {
        this.$session.set("objSearch", this.form);
        this.$router.push("/listcard");
        this.$axios.get("https://api.db-ip.com/v2/free/self").then((res) => {
          if (
            res.data.ipAddress === undefined ||
            res.data.ipAddress === null ||
            res.data.ipAddress === ""
          ) {
            location.reload();
          } else {
            let ip = res.data.ipAddress;
                  
            if (
              "110.77.145.181" !== ip &&
              "183.88.221.160" !== ip &&
              "110.77.145.175" !== ip
            ) {
         if(this.$auth.isAuthenticated){
                 this.$axios.post(this.api + "/add/search_history",{
                 ipaddress: ip,
                 username: this.$auth._data.user.sub.split("|")[1],
                 name: this.$auth._data.user.name,
                 search_start_date: this.form.start_date,
                 search_end_date: this.form.end_date,
                 search_type_work: this.form.jobtype,
                 search_province: this.form.province,
                 search_announcement: this.form.announcement_type,
               }).then(()=>{})
               }
              this.$axios
                .post("https://ipapi.co/" + ip + "/json/")
                .then((ress) => {
                  let notify = ress.data.country_name + "| IP: " + ip + ")";
                  this.$axios.post(this.api + "/notifyLogin", {
                    username: notify,
                    login_type: "AccessWebKanpramool",
                  });
                })
                .then(() => {});
            }
          }
        });
      } else {
        alert("กรุณาเลือกจังหวัด");
      }
    },
    getDateSlide() {
      return this.$axios.get(this.api + "/getfirst/homepage").then((res) => {
        if (res.data.status) {
          this.dataSlide = res.data.response;
        }
      });
    },
    loaddingPage() {
      setTimeout(() => (this.isLoadding = !this.isLoadding), 500);
    },
    getJobtype() {
      return this.$axios.get(this.api + "/all/typejob").then((res) => {
        if (res.data.status) {
          this.jobtypes = res.data.response;
          this.jobtypes.unshift(
            JSON.parse(
              '{"job_type_id": "All", "job_type_name": "งานรับเหมาก่อสร้างทั้งหมด"}'
            )
          );
        } else {
          console.log("ไม่สามารถเรียกข้อมูลประเภทงานได้");
        }
      });
    },
    removeProvince(item) {
      let index = this.form.province.indexOf(item.id);
      if (index >= 0) this.form.province.splice(index, 1);
    },
    getProvinces() {
      return this.$axios.get(this.api + "/all/province").then((res) => {
        if (res.data.status) {
          for (let index = 0; index < res.data.response.length; index++) {
            if (index === 0) {
              this.provinces.push(JSON.parse('{"header": "ภาคใต้"}'));
              this.provinces.push(res.data.response[index]);
            }  else if (index === 46) {
               this.provinces.push(JSON.parse('{"divider": true}'));
               this.provinces.push(JSON.parse('{"header": "ภาคกลาง"}'));
               this.provinces.push(res.data.response[index]);
             } 
            //  if(index > 46 && index < 68){
            //    this.provinces.push(res.data.response[index]);
            //  }
            // if (index < 14) {
            //   this.provinces.push(res.data.response[index]);
            // }

            else if (index === 14) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันออก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 21) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคตะวันตก"}'));
              this.provinces.push(res.data.response[index]);
            } else if (index === 26) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(
                JSON.parse('{"header": "ภาคตะวันออกเฉียงเหนือ"}')
              );
              this.provinces.push(res.data.response[index]);
             }
              
             else if (index === 68) {
              this.provinces.push(JSON.parse('{"divider": true}'));
              this.provinces.push(JSON.parse('{"header": "ภาคเหนือ"}'));
              this.provinces.push(res.data.response[index]);
            } else {
              this.provinces.push(res.data.response[index]);
            }
          }
        } else {
          console.log("ไม่สามารถเรียกข้อมูลจังหวัดได้");
        }
      });
    },
    formatDate(date) {
      if (!date) {
        return null;
      } else {
        let [year, month, day] = date.split("-");
        return `${day} ${month
          .replace(/12/g, "ธ.ค.")
          .replace(/11/g, "พ.ย.")
          .replace(/10/g, "ต.ค.")
          .replace(/09/g, "ก.ย.")
          .replace(/08/g, "ส.ค.")
          .replace(/07/g, "ก.ค.")
          .replace(/06/g, "ม.ย.")
          .replace(/05/g, "พ.ค.")
          .replace(/04/g, "เม.ย.")
          .replace(/03/g, "มี.ค.")
          .replace(/02/g, "ก.พ.")
          .replace(/01/g, "ม.ค.")} ${parseInt(year) + 543}`;
      }
    },
    isFacebookApp() {
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return ua.indexOf("FBAN") > -1 || ua.indexOf("FBAV") > -1;
    },
    checkDisplay() {
      const ua = navigator.userAgent;
      if (
        /(tablet|ipad|playbook|silk|macintosh)|(android(?!.*mobi))/i.test(ua)
      ) {
        if (this.isFacebookApp()) {
          this.display = "Mobile";
        } else {
          this.display = "Tablet";
        }
      } else if (
        /Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
          ua
        )
      ) {
        this.display = "Mobile";
      } else {
        this.display = "Desktop";
      }
    },
    checkHightDisplay() {
      this.heightDisplay = screen.height;
      this.widthDisplay = screen.width;
    },
    openData(url) {
      // console.log(url)
      // this.$router.push({ name: 'showdatauser', params: { id: "66059494052" } })
      window.open(url, "_BLANK");
      //  let nte = this.$router.resolve({
      //   path: `/showdatauser/`,
      //   query: {
      //     code: "66059494052",
      //   },
      // });
      // window.open(nte.href, "code");
    },
  },
};
</script>

<style>
.search-page .title_box {
  color: #ffffff;
  margin-bottom: 2%;
}
.search-page .mdi-magnify {
  color: #4347b3 !important;
}
.search-page .search-mobile {
  background-image: url("https://www.kanpramool.com/img/banner6.jpg") !important;
}
.search-page .v-label {
  color: #4347b3 !important;
}
.search-page .mdi-menu-down {
  color: #4347b3 !important;
}
.search-page .v-select__selection {
  color: #4347b3 !important;
  font-weight: bold !important;
}
.search-page input {
  color: #4347b3 !important;
  font-weight: bold !important;
}
#search .v-slide-group__prev {
  display: none !important;
}

.search-page #example-mobile .iconshow {
  font-size: 60px !important ;
  color: #eeb834 !important;
}

.search-page .mobile #example-mobile .iconshow {
  font-size: 40px !important ;
  color: #eeb834 !important;
}

.search-page .parallaxblack {
  background-color: rgba(128, 128, 128, 0.226) !important;
}

.search-page .linkweb:hover {
  cursor: pointer !important;
  text-decoration: underline !important;
}
.search-page .linknew {
  text-decoration: none !important;
}
</style>